import { TrackingApi, useAPIAction } from "melco-shared-logic";

export const useDownloadDailySummaryReport = (
  productCode: string,
  dateRange: any,
  userId: string
) => {
  return useAPIAction(
    TrackingApi,
    async (api) => {
      const data = await api.analyticExportDownloadSummary({
        productCode: productCode,
        startTimestamp: dateRange.start,
        endTimestamp: dateRange.end,
        format: "csv",
      });

      console.log(data);
      return {
        successMessages: [],
        data,
      };
    },
    {
      defaultApiConfigOptions: { impersonationForId: userId },

      translationPrefix: "global",
    }
  );
};
